import React, { useEffect, useState } from 'react';
import {
  Alert,
  Button,
  Col,
  Container,
  Modal,
  OverlayTrigger,
  Row,
  Tooltip,
  Form
} from 'react-bootstrap';
import { FaCheck } from 'react-icons/fa';
import './style.css';
import useHttpApiCall from '../../services/useHttpApiCall';
import AddMachineStatus from './addMachineStatus';
import MachineStatusCustomizeContainer from '../machinestatus/containers/machine.status.customize.container';
import { setCustomiseButtonClick } from '../../redux/customiseValues/filterbutton/customiseButton';
import { useDispatch } from 'react-redux';

const CreateForm = ({ itemList, slides, editForm, editData, setReloadData, handleCloseModal }) => {
  const [selectedItems, setSelectedItems] = useState([]);
  const [payload, setPayload] = useState('');
  const [payload1, setPayload1] = useState();
  const [schedulePayload, setSchedulePayload] = useState();
  const [data2, loading2] = useHttpApiCall(payload1);
  const [data1] = useHttpApiCall(schedulePayload);

  const [showToast, setShowToast] = useState(false);
  const [validationError, setValidationError] = useState('');
  const [customiseModalVisibility, setCustomiseModalVisibility] = useState(false);
  const [machineStatusEnabled, setMachineStatusEnabled] = useState(false);
  const [openMachineStatusSlider, setOpenMachineStatusSlider] = useState(false);
  const [selectedEquipment, setSelectedEquipment] = useState(null);
   const [, setCustomizeUpdate] = useState({ filterGraphId: null, update: false });
  
  const dispatch = useDispatch();

  // Load equipment list for machine status
  const handleLoadEquipmentList = () => {
    setSchedulePayload({
      auth: true,
      url: `v1/layers/equipments/`,
      params: {
        layer_type: 'company',
        equipment_type: 1,
        is_shop_floor_view: 3      }
    });
  };

  // Handle machine status toggle
  const handleMachineStatusToggle = () => {
    setMachineStatusEnabled(!machineStatusEnabled);
  };

  // Initialize selected items from edit data
  useEffect(() => {
    if (slides) {
      editData?.equipment?.length > 0 &&
        setSelectedItems(editData?.equipment?.map((item) => item?.source_mapping));
    } else {
      editData?.slides?.length > 0 &&
        setSelectedItems(editData?.slides?.map((item) => item?.slide));
    }
  }, [itemList, editData, slides]);

  // Initialize payload from edit data
  useEffect(() => {
    if (editForm && editData) {
      setPayload(editData?.name || '');
      setMachineStatusEnabled(!!editData.use_machine_status);
    }
  }, [editForm, editData]);

  // Handle successful submission
  useEffect(() => {
    if (data2?.status === 200) {
      setReloadData();
      handleCloseModal();
    }
  }, [data2, setReloadData, handleCloseModal]);

  // Handle item selection
  const handleItemClick = (e, item) => {
    if (e.target.checked) {
      setSelectedItems((prev) => [...prev, item?.id]);
    } else {
      setSelectedItems(selectedItems?.filter((prevItem) => prevItem !== item?.id));
    }
  };

  // Adapt handleItemClick for ScheduleForm2 component
  const adaptedHandleItemClick = (checked, item) => {
    const mockEvent = { target: { checked } };
    handleItemClick(mockEvent, item);
  };

  // Handle machine status click
  const handleAddMachineStatusClick = (item) => {
    setSelectedEquipment(item);
    setCustomiseModalVisibility(false); // Close the current modal
    setOpenMachineStatusSlider(true); // Open machine status slider
    
    // Dispatch the equipment data for machine status customization
    dispatch(setCustomiseButtonClick(item));
  };

  // Handle machine status slider close
  const handleCloseMachineStatus = () => {
    setOpenMachineStatusSlider(false);
    setSelectedEquipment(null);
    // Refresh equipment list if needed
    handleLoadEquipmentList();
  };

  // Handle form submission
  const handleSubmit = () => {
    // Validation
    if (!payload?.trim()) {
      setValidationError('Please enter a name');
      return;
    }

    if (selectedItems?.length === 0) {
      setValidationError(slides ? 'Please select at least one equipment' : 'Please select at least one slide');
      return;
    }

    setValidationError('');

    // Prepare API call based on mode
    const apiData = {
      name: payload,
      is_active: true,
      use_machine_status: machineStatusEnabled
    };

    if (slides) {
      apiData.tagged_equipment = selectedItems;
    } else {
      apiData.tagged_slides = selectedItems;
    }

    if (editForm) {
      const endpoint = slides 
        ? `v0/shop-floor-view/slides/${editData?.id}/`
        : `v0/shop-floor-view/slide-shows/${editData?.id}/`;
      
      setPayload1({
        auth: true,
        url: endpoint,
        method: 'PUT',
        data: apiData
      });
    } else {
      const endpoint = slides 
        ? 'v0/shop-floor-view/slides/'
        : 'v0/shop-floor-view/slide-shows/';
      
      setPayload1({
        auth: true,
        url: endpoint,
        method: 'POST',
        data: apiData
      });
    }
  };

  // Handle input change
  const handleChange = (e) => {
    setPayload(e.target.value);
  };

  // Show success toast
  useEffect(() => {
    if (data2?.data?.status === 1) {
      setShowToast(true);
      setTimeout(() => {
        setShowToast(false);
      }, 3000);
    }
  }, [data2]);

  // Truncate text utility
  // const truncateText = (text, maxLength) => {
  //   if (text?.length > maxLength) {
  //     return text.slice(0, maxLength) + '...';
  //   }
  //   return text;
  // };

  // Handle close custom modal
  const handleCloseCustomModal = () => {
    setCustomiseModalVisibility(false);
    handleLoadEquipmentList(); // Refresh data when closing
  };

  // Open machine status modal
  const handleOpenMachineStatusModal = () => {
    handleLoadEquipmentList();
    setCustomiseModalVisibility(true);
  };

  return (
    <div className="shopfloorForm">
      {/* Machine Status Customization Slider */}
      {openMachineStatusSlider && (
        <MachineStatusCustomizeContainer
          openMachineStatusSlider={openMachineStatusSlider}
          processDetails={{
            ShopFloorView: true,
            drilldownlevel: 'Process',
            process_type: 'Production',
            process_id: selectedEquipment?.process,
            sub_process_id: selectedEquipment?.sub_process_id,
            equipment_id: selectedEquipment?.equipment_id,
            layer_id: selectedEquipment?.layer_id,
            layer_type: selectedEquipment?.layer_type,
            plant_code: selectedEquipment?.plant_code
          }}
          setOpenMachineStatusSlider={setOpenMachineStatusSlider}
            setCustomizeUpdate={setCustomizeUpdate}
          handleClose={handleCloseMachineStatus}
        />
      )}

      {/* Validation Errors */}
      {validationError && (
        <Alert variant="danger" onClose={() => setValidationError('')} dismissible>
          {validationError}
        </Alert>
      )}

      {/* Machine Status Modal */}
      <Modal show={customiseModalVisibility} onHide={handleCloseCustomModal} size="lg">
        <Modal.Body className="customiseModalForm">
          <AddMachineStatus
            equipmentList={data1?.data?.data || []}
            // truncateText={truncateText}
            handleAddMachineStatusClick={handleAddMachineStatusClick}
            selectedItems={selectedItems}
            handleItemClick={adaptedHandleItemClick}
            handleCloseModal={handleCloseCustomModal}
          />
        </Modal.Body>
      </Modal>

      {/* Success Toast */}
      <Alert
        className="sidebar-slider_alert"
        show={showToast}
        variant="success"
        onClose={() => setShowToast(false)}>
        <p className="text-center">
          {editForm ? 'Data updated successfully' : 'Data created successfully'}
        </p>
      </Alert>

      {/* Form Content */}
      <Form.Group className="mb-3 ms-1">
        <Form.Label>{slides ? 'Slide name' : 'Slide show name'}</Form.Label>
        <Form.Control
          className="shadow-sm"
          type="text"
          name="name"
          placeholder={slides ? 'Enter slide name' : 'Enter slide show name'}
          value={payload}
          onChange={handleChange}
        />
      </Form.Group>

      {/* Machine Status Toggle (only for slide shows) */}
      {!slides && (
        <Form.Group className="mb-3">
          <div className="d-flex align-items-center mb-2">
            <Form.Label className="mb-0 me-2">
  Machine Status <span style={{ opacity: 0.4 }}>(on/off)</span>
</Form.Label>

            <label className="switch mt-1">
              <input
                type="checkbox"
                checked={machineStatusEnabled}
                onChange={handleMachineStatusToggle}
              />
              <span className="slider round"></span>
            </label>
          </div>

         

          <div>
            <small className="machine-status-description">
              If machine status is on (and limits are set), the equipment in your slides will always
              have a background color that corresponds to their current status. Off (gray), standby
              (red), sleep-mode (yellow) and production (green).
              <span
                className="ms-1 text-primary"
                style={{ cursor: 'pointer' }}
                onClick={handleOpenMachineStatusModal}>
                Click here to add limits for machine status.
              </span>
            </small>
          </div>
        </Form.Group>
      )}

      {/* Item List */}
      <div className="optionList">
        <label className="mb-2 ms-2">{slides ? 'Equipment' : 'Slides'}</label>
        <Container>
          {itemList?.length > 0 ? (
            itemList?.map((item) => (
              <div key={item?.id} className="listItem text-muted small">
                <Row className="my-1">
                  <OverlayTrigger
                    placement="bottom"
                    overlay={
                      <Tooltip id="tooltip-bottom">
                        {slides ? item?.equipment_name : item?.name}
                      </Tooltip>
                    }>
                    <Col
                      xs={4}
                      style={{ color: '#a1a4a6' }}
                      title={slides ? item?.equipment_name : item?.name}>
                      {(slides ? item?.equipment_name : item?.name)}
                    </Col>
                  </OverlayTrigger>
                  <Col xs={6}></Col>
                  <Col className="d-flex justify-content-end align-items-center">
                    <label className="custom-checkbox">
                      <input
                        type="checkbox"
                        checked={selectedItems?.includes(item?.id)}
                        onChange={(e) => handleItemClick(e, item)}
                      />
                      <span className="checkmark">
                        <FaCheck className="check-icon" />
                      </span>
                    </label>
                  </Col>
                </Row>
              </div>
            ))
          ) : (
            <div className="text-muted text-center py-3">No items available</div>
          )}
        </Container>
      </div>

      {/* Submit Button */}
      <div className="addNewButton">
        <Button
          className="mt-4 btn-grad btn btn-primary"
          onClick={handleSubmit}
          disabled={loading2}>
          {loading2 ? 'Loading...' : editForm ? 'Update' : 'Submit'}
        </Button>
      </div>
    </div>
  );
};

export default CreateForm;